module.exports = __webpack_public_path__ + "static/logo-bloomberg@2x-9aed7e832b42a2229ff19f67837c3b91.png";